import { Table, TableContainer, Paper, Typography, TableHead, TableRow, TableCell, TableBody } from "@mui/material"
const RangeContinuityInfo = () => {
    return (
        <>
            <Typography fontSize={14.5}>Example of Range Condition in Continuity:</Typography>
            <TableContainer component={Paper} sx={{mb:0.5}}>
            <Paper className="lease-detail-table" >
                    <Table className="mui-table-format"    >
                        <TableHead>
                            <TableRow>
                                <TableCell>Range Conditions</TableCell>
                                <TableCell>MIN*</TableCell>
                                <TableCell>MAX*</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow >
                                <TableCell style={{ padding: '5px' }}>Less Than Equal To</TableCell>
                                <TableCell>
                                    0
                                </TableCell>
                                <TableCell>
                                    50
                                </TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell style={{ padding: '5px' }}>In Between Equal To</TableCell>
                                <TableCell>50.01</TableCell>
                                <TableCell>100</TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell style={{ padding: '5px' }}>Greater Than Equal To</TableCell>
                                <TableCell>100.01</TableCell>
                                <TableCell>0</TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                    </Paper>
            </TableContainer>

        </>
    )
}

export default RangeContinuityInfo